/** 0.372 → «37%». Отрицательные значения обрезаются до 0. */
export const pct = (p: number): string => `${Math.round(Math.max(0, p) * 100)}%`;

/** Русское склонение: plural(2, 'ход', 'хода', 'ходов'). */
export function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
  return many;
}
